module.exports = __webpack_public_path__ + "img/Feature.d6fdd41e.jpg";